var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-overlay",class:{ show: _vm.showSidebarOverlay },on:{"click":_vm.handleOverlayClick}}),_vm._v(" "),_c('div',{class:{
      open: _vm.show,
      full: _vm.fullWidth,
      'f-mobile-sidebar-view': _vm.forceMobileView,
      'c-mobile-sidebar': !_vm.forceMobileView
    },attrs:{"id":_vm.id}},[(_vm.$slots.header)?_c('div',{staticClass:"header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"facets-container"},[_vm._t("body")],2),_vm._v(" "),(_vm.$slots.footer)?_c('footer',{staticClass:"footer"},[_vm._t("footer")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }